/* Replace every <span data-icon="name"> with its SVG - no ui.js dependency.
   Custom kitchen art: <span data-nav-art="ASSET_JAR"> uses CSS mask + theme color. */
import { icon, brandMark, discordIcon, episodeIcon, instagramIcon } from "./icons.js?v=20261007m";
import { withAssetVersion } from "./asset-version.js?v=20261007m";

const brandIcons = {
  brand: brandMark,
  discord: discordIcon,
  episode: episodeIcon,
  instagram: instagramIcon,
};

/** Paint data-nav-art slots with themed SVG/PNG masks from /img/* */
export function fillNavArt(root = document) {
  root.querySelectorAll("[data-nav-art]").forEach((el) => {
    const file = String(el.dataset.navArt || "").trim();
    if (!file) return;
    const hasExt = /\.[a-z0-9]+$/i.test(file);
    const fileName = hasExt ? file : `${file}.svg`;
    const src = withAssetVersion(`img/${fileName}`);
    el.classList.add("nav__art");
    el.setAttribute("aria-hidden", "true");
    if (el.hasAttribute("data-full-color") || file.toUpperCase() === "TV.PNG" || file.toUpperCase() === "TV") {
      el.style.webkitMaskImage = "none";
      el.style.maskImage = "none";
      el.style.backgroundColor = "transparent";
      el.style.backgroundImage = `url("${src}")`;
      el.style.backgroundSize = "contain";
      el.style.backgroundRepeat = "no-repeat";
      el.style.backgroundPosition = "center";
    } else {
      el.style.webkitMaskImage = `url("${src}")`;
      el.style.maskImage = `url("${src}")`;
    }
    el.innerHTML = "";
  });
}

export function fillIcons(root = document) {
  root.querySelectorAll("[data-icon]").forEach((el) => {
    if (el.hasAttribute("data-nav-art")) return;
    const name = el.dataset.icon;
    el.innerHTML = brandIcons[name] ? brandIcons[name]() : icon(name);
  });
  fillNavArt(root);
}
